// extracted by mini-css-extract-plugin
export var active = "_i9-2";
export var recordingDot = "_i9-1";
export var recordingIndicator = "_i9-0";